import useSocketEvent from '../hooks/useSocketEvent';
import { FILTER_VALUE_ACTIVOS } from '../const/filtersValue/filterValue';
import { newMessageEntry, newMessageInInbox } from '../helpers/array';
import { deleteChat } from '../helpers/array';
import { onHandleEndSession } from '../helpers/array';
import { useEffect, useState } from 'react';

// Componente que renderiza el controlador de Eventos del Socket.
// Leer más en la documentación del componente en "/docs"
const SocketEventHandlerComponent = ({
    chatsArray,
    setChatsArray,
    filterValue,
    sessionsChatSelected,
    setSessions,
    chatData,
    setChatsOriginal, 
    chatsOriginal,
    searching }) => {

    const [listChats, setListChats] = useState([]);

    const onNewMessage = (newChat) => { //Función para setear un nuevo chat entrante en el inbox.
        if (filterValue === FILTER_VALUE_ACTIVOS) {
            let updatedChatsOriginal = newMessageInInbox(chatsOriginal, newChat, false); //Invocar al helper que retorna la lista de chats actualizada con el nuevo mensjae entrante.
            let updatedChats = newMessageInInbox(chatsArray, newChat, searching); //Invocar al helper que retorna la lista de chats actualizada con el nuevo mensjae entrante.
            setChatsOriginal(updatedChatsOriginal); // Actualizar la lista de chats con los chats en tiempo real.
            setChatsArray(updatedChats); // Actualizar la lista de chats que se muestra en el inbox.
        }
    };

    //Llamar al evento del socket para concatenar un nuevo chat el el Inbox.
    useSocketEvent("newMessage", (data) => { onNewMessage(data) });
    
    //Llamar al evento del socket para concatenar un nuevo mensaje el Chat de la sesión abierta.
    useSocketEvent("newMessage", (data) => {newMessageEntry(data, sessionsChatSelected, setSessions, chatData); });

    //Llamar al evento del socket para eliminar un chat el el Inbox.
    useSocketEvent("deleteChat", (data) => { deleteChat(data, listChats, setChatsOriginal, setChatsArray)});
    
     //Llamar al evento del socket para finalizar una sesión del chat abierto.
     useSocketEvent("endSession", (data) => { onHandleEndSession(data, sessionsChatSelected, setSessions) });
 
    useEffect(()=> setListChats(chatsOriginal), [chatsOriginal]);

    return null; // El componente no renderiza nada en el DOM, solo ejecuta efectos.
};

export default SocketEventHandlerComponent;
